import React from "react";
import { Grid, TextField } from "@mui/material";

const WarehouseInfo = (props) => {
  const { handleChange, warehouse } = props;

  return (
    <form
      margin="dense"
      noValidate
      autoComplete="off"
      style={{ width: "100%" }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            InputProps={{
              inputProps: {
                autoComplete: "off",
              },
            }}
            size="small"
            variant="outlined"
            label="Name"
            name="name"
            value={warehouse && warehouse.name}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default WarehouseInfo;
